import { useCallback, useMemo, useState } from 'react'
import useSettingsConnections from '@/hooks/useSettingsConnections'
import { useIntegrationsModalOptional } from '@/components/IntegrationsModal/IntegrationsModalContext'
import { useConnectionRowMenuActions } from './useConnectionRowMenuActions'

export function useConnectionsDirectoryModel() {
  const [query, setQuery] = useState('')
  const { connections = [], isLoading, error } = useSettingsConnections()
  const integrationsModal = useIntegrationsModalOptional()
  const [menuAnchor, setMenuAnchor] = useState(null)
  const [menuRowId, setMenuRowId] = useState(null)
  const [permissionConnectionId, setPermissionConnectionId] = useState(null)
  const filteredConnections = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return connections
    return connections.filter(
      (row) => row.title.toLowerCase().includes(q) || row.toolkitSlug.toLowerCase().includes(q),
    )
  }, [connections, query])
  const handleOpenRowMenu = useCallback((event, rowId) => {
    event.stopPropagation()
    setMenuAnchor(event.currentTarget)
    setMenuRowId(rowId)
  }, [])
  const handleCloseRowMenu = useCallback(() => {
    setMenuAnchor(null)
    setMenuRowId(null)
  }, [])
  const handleRowMenuSelect = useConnectionRowMenuActions({ menuRowId, connections, onPermissions: setPermissionConnectionId })
  return {
    query,
    setQuery,
    filteredConnections,
    isLoading,
    error,
    // An outage must not render as "no connected apps" — that would invite the
    // user to reconnect apps they already have.
    listEmpty: connections.length === 0 && !isLoading && !error,
    searchNoHits: connections.length > 0 && filteredConnections.length === 0,
    menuAnchor,
    menuRowId,
    handleOpenRowMenu,
    handleCloseRowMenu,
    handleRowMenuSelect,
    permissionConnectionId,
    closePermissions: () => setPermissionConnectionId(null),
    openIntegrations: integrationsModal?.openIntegrations ?? null,
  }
}
